import type { RouteProps } from "react-router-dom";
import { Redirect, Route } from "react-router-dom";
import { useIsLogged } from "../hooks/use-is-logged/use-is-logged";
import { useAbility } from "../hooks/useAbilityRules";

type Actions = "create" | "readOne" | "readAll" | "update" | "delete";
interface PrivateRouteProps extends RouteProps {
  readonly allowedIf?: { can: Actions; model: string };
  readonly redirectTo?: string;
}

function ABACRoute({ children, allowedIf, redirectTo, ...rest }: PrivateRouteProps) {
  const isLogged = useIsLogged();
  const ability = useAbility();

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLogged && (allowedIf ? ability.can(allowedIf.can, allowedIf.model) : true) ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: redirectTo || "/welcome",
              state: { from: location },
            }}
            push={true}
          />
        )
      }
    />
  );
}

export default ABACRoute;
